import React, { /* useContext, */ useEffect, useMemo } from 'react';
import { BrowserRouter, useInRouterContext } from 'react-router-dom';
import {
  Provider as ReduxProvider,
  // ReactReduxContext,
  useDispatch,
} from 'react-redux';
import { ApiProvider } from './context/ApiContext';
import { ThemeProvider, useTheme } from './context/ThemeContext';
import defaultStore from './redux/store';
import App from './App';
import { setAppDetails } from './redux/appDetails/reducer';
import './styles/index.css';
import { CompanyContext } from './context/CompanyContext';

function ThemedShell({ children }) {
  const { cssVars, darkMode, mode } = useTheme();

  return (
    <div
      className={`ca-root ${darkMode ? 'ca-root--dark' : 'ca-root--light'}`}
      data-ca-theme={mode}
      style={cssVars}
    >
      {children}
    </div>
  );
}

function OptionalRouter({ basePath, children }) {
  const hasParentRouter = useInRouterContext();

  if (hasParentRouter) return children;
  return <BrowserRouter basename={basePath}>{children}</BrowserRouter>;
}

// function OptionalReduxProvider({ store, children }) {
//   const parentRedux = useContext(ReactReduxContext);
//   if (!store && parentRedux?.store) return children;
//   return <ReduxProvider store={store || defaultStore}>{children}</ReduxProvider>;
// }
function OptionalReduxProvider({ store, children }) {
  return (
    <ReduxProvider store={store || defaultStore}>
      {children}
    </ReduxProvider>
  );
}

function AppDetailsSync({ details, children }) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setAppDetails(details));
  }, [dispatch, details]);

  return children;
}

const EMPTY_LIST = [];

const ComplaintApp = ({
  apiUrl,
  authToken,
  store,
  basePath = '/',
  theme,
  darkMode = false,
  title,
  description,
  rolelist,
  roleList = rolelist ?? EMPTY_LIST,
  storeList,
  company,
  useDemoData = true,
  createLabel,
  onCreateForm,
  onConfigure,
  onOpen,
  onTitleClick,
  onDescriptionClick,
  onSearch,
  onPublish,
  onSaveDraft,
  showSaveButton,
  showNextButton,
  onStepChange,
  children,
}) => {
  const pageProps = {
    title,
    description,
    useDemoData,
    createLabel,
    onCreateForm,
    onConfigure,
    onOpen,
    roleList,
    storeList,
    company,
    onTitleClick,
    onDescriptionClick,
    onSearch,
    onSaveDraft,
    showSaveButton,
    showNextButton,
  };

  const appDetails = useMemo(
    () => ({
      apiUrl,
      authToken,
      basePath,
      theme,
      darkMode,
      title,
      description,
      roleList,
      storeList,
      company,
      useDemoData,
      createLabel,
      onCreateForm,
      onConfigure,
      onOpen,
      onTitleClick,
      onDescriptionClick,
      onSearch,
      onPublish,
      onSaveDraft,
      showSaveButton,
      showNextButton,
      onStepChange,
    }),
    [
      apiUrl,
      authToken,
      basePath,
      theme,
      darkMode,
      title,
      description,
      roleList,
      storeList,
      company,
      useDemoData,
      createLabel,
      onCreateForm,
      onConfigure,
      onOpen,
      onTitleClick,
      onDescriptionClick,
      onSearch,
      onPublish,
      onSaveDraft,
      showSaveButton,
      showNextButton,
      onStepChange,
    ],
  );

  return (
    <CompanyContext.Provider value={company}>
    <ThemeProvider theme={theme} darkMode={darkMode}>
      <OptionalReduxProvider store={store}>
        <AppDetailsSync details={appDetails}>
          <ThemedShell>
            <ApiProvider apiUrl={apiUrl} authToken={authToken}>
              <OptionalRouter basePath={basePath}>
                <App
                  pageProps={pageProps}
                  onPublish={onPublish}
                  onStepChange={onStepChange}
                >
                  {children}
                </App>
              </OptionalRouter>
            </ApiProvider>
          </ThemedShell>
        </AppDetailsSync>
      </OptionalReduxProvider>
    </ThemeProvider>
    </CompanyContext.Provider>
  );
};

export default ComplaintApp;
